import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import './UserProfileFooter.scss';
import { NO_OP } from '../../constants/Constants';
const UserProfileFooter = props => {
  const {
    handleCancel,
    handleSave,
    disableSubmit,
    isUserDataUpdated
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, {
    className: "footer-cancel-btn",
    onClick: handleCancel
  }, " ", __('Cancel'), " "), /*#__PURE__*/React.createElement(Button, {
    className: "footer-save-btn",
    onClick: handleSave,
    disabled: disableSubmit,
    loading: isUserDataUpdated
  }, " ", __('Save'), " "));
};
UserProfileFooter.propTypes = {
  handleCancel: PropTypes.func,
  handleSave: PropTypes.func,
  disableSubmit: PropTypes.bool,
  isUserDataUpdated: PropTypes.bool
};
UserProfileFooter.defaultProps = {
  handleCancel: NO_OP,
  handleSave: NO_OP,
  disableSubmit: false,
  isUserDataUpdated: false
};
export default UserProfileFooter;